module.exports = __webpack_public_path__ + "img/img01_text.679d6020.png";